import React from "react";
import { FaSearch, FaSlidersH } from "react-icons/fa";

interface SearchFilterBarProps {
  search: string;
  onSearchChange: (value: string) => void;
  placeholder?: string;

  onFilterClick: () => void;
  filterActive?: boolean;

  className?: string;
}

const SearchFilterBar: React.FC<SearchFilterBarProps> = ({
  search,
  onSearchChange,
  placeholder = "Search...",
  onFilterClick,
  filterActive = false,
  className = "",
}) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* SEARCH */}
      <div className="relative flex-1">
        {FaSearch ({className:"absolute left-4 top-1/2 -translate-y-1/2 text-sm text-slate-400" })}

        <input
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={placeholder}
          className="h-11 w-full rounded-xl border border-slate-200 bg-slate-50 pl-11 pr-4 text-sm outline-none transition placeholder:text-slate-400 focus:border-blue-500 focus:bg-white focus:ring-4 focus:ring-blue-500/10"
        />
      </div>

      {/* FILTER */}
      <button
        type="button"
        title="Filter"
        aria-label="Filter"
        onClick={onFilterClick}
        className={`relative flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border transition ${
          filterActive
            ? "border-blue-200 bg-blue-50 text-blue-600"
            : "border-slate-200 bg-white text-slate-500 hover:border-slate-300 hover:bg-slate-50"
        }`}
      >
        {FaSlidersH ({className:"text-sm"})}

        {filterActive && (
          <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-blue-600 ring-2 ring-white" />
        )}
      </button>
    </div>
  );
};

export default SearchFilterBar;